import Articles from './articles';

export default Articles;
